/**
 * The discover fiverr related cookies name.
 * @type {Object<String>}
 */
export const DISCOVER_FIVERR_COOKIES = {
    DISMISS: 'hide_locale_redirect',
    GUEST_LOCALE: 'guest_locale'
};

/**
 * The expiry time of discover fiverr related cookies.
 * @type {Number}
 */
export const COOKIE_EXPIRES = 1000 * 3600 * 24 * 7; // 1 week

/**
 * The supported events this component emits.
 * @type {Object<String>}
 */
export const EVENT_TYPES = {
    SHOW: 'show',
    DISMISS: 'dismiss',
    CLICK: 'click'
};

/**
 * Holds the event type to tracking platform data mapping.
 * @type {Object<String>}
 */
export const EVENTS = {
    [EVENT_TYPES.SHOW]: {
        bigQuery: 'localization_bomba_popup_show',
        mixpanel: 'locale bomba show',
        grafana: 'localization.redirect_bomba.show'
    },
    [EVENT_TYPES.DISMISS]: {
        bigQuery: 'clicked_on_localization_bomba_close',
        mixpanel: 'locale bomba dismissed',
        grafana: 'localization.redirect_bomba.dismissed'
    },
    [EVENT_TYPES.CLICK]: {
        bigQuery: 'clicked_on_localization_bomba_language',
        mixpanel: 'locale bomba - changed language',
        grafana: 'localization.redirect_bomba.clicked'
    }
};

/**
 * The discover fiverr translations scope prefix.
 * @type {String}
 */
export const DISCOVER_FIVERR_TRANSLATION_PREFIX = 'layout.global_messages.discover_fiverr';
